import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Reminder",
  "use": "icon-Reminder-usage",
  "viewBox": "0 0 21 21",
  "content": "<symbol viewBox=\"0 0 21 21\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-Reminder\">\n<path d=\"M10.6464 17.8528C14.5023 17.8528 17.6282 14.7269 17.6282 10.871C17.6282 7.01504 14.5023 3.88916 10.6464 3.88916C6.79043 3.88916 3.66455 7.01504 3.66455 10.871C3.66455 14.7269 6.79043 17.8528 10.6464 17.8528Z\" stroke=\"#67788C\" stroke-width=\"1.66667\" stroke-linejoin=\"round\" />\n<path d=\"M10.555 6.81641L10.5542 11.0086L13.5144 13.9688\" stroke=\"#67788C\" stroke-width=\"1.66667\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M3.02979 4.39684L5.69562 2.49268\" stroke=\"#67788C\" stroke-width=\"1.66667\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M18.263 4.39684L15.5972 2.49268\" stroke=\"#67788C\" stroke-width=\"1.66667\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/Reminder.svg
// module id = F6v2
// module chunks = 262